import { isValid12HourTimeFormat } from '@/lib/validation/hour';
import { format } from 'date-fns';
import { loadTimeSelectOptions } from '../utils/timeSelectUtils';

export interface TimeOption {
  label: string;
  value: Date;
} // Helper function to generate time options from 12:00am to 11:45pm
export const generateTimeOptions = (
  baseDate: Date,
  additionalOptions: TimeOption[] = []
): TimeOption[] => {
  const options: TimeOption[] = [];

  // Start from 12:00am (midnight)
  const startHour = 0;
  const endHour = 23;

  for (let hour = startHour; hour <= endHour; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const date = new Date(baseDate);
      date.setHours(hour, minute, 0, 0);

      const timeLabel = format(date, 'h:mmaaa');

      options.push({
        label: timeLabel,
        value: date
      });
    }
  }

  if (additionalOptions.length > 0) {
    additionalOptions.forEach((option) => {
      if (!options.find((o) => o.value.getTime() === option.value.getTime())) {
        options.push(option);
      }
    });

    options.sort((a, b) => a.value.getTime() - b.value.getTime());
  }

  return options;
};

// Helper function to load and filter time options
export const loadTimeOptions = (
  filterValue: string,
  baseDate: Date,
  timeOptions: TimeOption[]
) => {
  return loadTimeSelectOptions({
    options: timeOptions,
    filterValue,
    baseDate,
    createOption: getOptionFromTime,
    searchOption: (option, filter) =>
      option.label.toLowerCase().includes(filter.toLowerCase()) ||
      option.label.padStart(7, '0').toLowerCase().includes(filter.toLowerCase())
  });
};

const getOptionFromTime = (baseDate: Date, filterTime: string) => {
  const filterDate = new Date(baseDate);
  const filterTimeParts = filterTime.split(':');
  filterDate.setHours(
    Number(filterTimeParts[0]) + (filterTime.includes('pm') ? 12 : 0),
    Number(filterTimeParts[1].replace('am', '').replace('pm', ''))
  );

  return {
    label: filterTime,
    value: filterDate
  };
};
